import React, { FC } from 'react';
import TextField from '@material-ui/core/TextField';

type PayoutAmountFieldProps = {
  // Each dialog keeps its own suffix convention ("Payout Amount $" on the
  // master sheet, "Payout Amount" on the job repair sheet).
  label: string;
  className?: string;
  // Resolved Allow Payout Amount Editing toggle. false renders the read-only
  // system value.
  editable: boolean;
  value: string;
  error: string | null;
  onChange: (value: string) => void;
};

// The Payout Amount field of both Add Contractor dialogs. One element, two
// modes: disabled text field showing the system value (toggle OFF), or an
// editable currency input following the manual Fixed Amount conventions
// (toggle ON).
export const PayoutAmountField: FC<PayoutAmountFieldProps> = ({
  label,
  className,
  editable,
  value,
  error,
  onChange,
}) => (
  <TextField
    id="payout-amount"
    label={label}
    fullWidth
    className={className}
    value={value}
    disabled={!editable}
    {...(editable
      ? {
          type: 'number',
          InputProps: { inputProps: { min: 0, title: '', step: 'any' } },
          onChange: (
            event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
          ) => onChange(event?.target.value),
          error: !!error,
          helperText: error,
        }
      : {})}
  />
);
